// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1g-0E","footer":"ModalCreateQualiphyProcedure_footer__AQE27","additionData":"ModalCreateQualiphyProcedure_additionData__3njMI"};